// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2684":"e66257b5","6785":"1839c6df"}[chunkId] + ".chunk.css";
};